import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

export interface RadioOption {
  value: string;
  label: string;
}

@Component({
  selector: 'app-radio-group',
  templateUrl: './radio-group.component.html',
})
export class RadioGroupComponent {
  @Input() control!: AbstractControl;
  @Input() label = '';
  @Input() required = false;
  @Input() submitted = false;
  @Input() errorMessages: { [key: string]: string } = {};
  @Input() serverError: string | null | undefined = '';
  @Input() options: RadioOption[] = [];
  @Input() name = '';

  @Output() optionClick = new EventEmitter<string>();

  get formControl(): FormControl {
    return this.control as FormControl;
  }
}
